import type { IconProps } from "./icon.interface";

export function Icon({ name, className, label }: IconProps) {
  return (
    <svg
      className={className}
      aria-hidden={label ? undefined : true}
      aria-label={label}
    >
      <use href={`/icons/sprite.svg#${name}`} />
    </svg>
  );
}
